import type { BattleBettingVolume } from "../../types/api.generated";

export type BattleBettingVolumeSnapshot = BattleBettingVolume;

export const getBattleBettingVolume = async (
  battleId: string
): Promise<BattleBettingVolume> => {
  const token = sessionStorage.getItem("tokenUser");
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const response = await fetch(`${base}/bets/battles/${battleId}/volume`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(
      text || `Failed to load battle betting volume: ${response.status}`
    );
  }

  return response.json();
};
